import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useBillings } from '@repo/domain-service';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function BillingExistsGuard() {
  const { id } = useParams<{ id: string }>();
  const { billings, loadingBilling } = useBillings();
  const navigate = useNavigate();

  const billing = billings.find((billing) => billing.id === id);

  useEffect(() => {
    if (!id || (!loadingBilling && !billing)) {
      navigate(ROUTE_PATHS[RouteName.ACCOUNT_BILLINGS], { replace: true });
    }
  }, [id, loadingBilling, billing, navigate]);

  if (!billing) {
    return null;
  }

  return <Outlet context={billing} />;
}
